import type { UseAuthStore } from '../types';

export function createAuthGuard(useAuthStore: UseAuthStore): React.FC<{
  children: React.ReactNode;
  fallback: React.ReactNode;
  loading?: React.ReactNode;
}> {
  return function AuthGuard({ children, fallback, loading = null }) {
    const isInitialized = useAuthStore(state => state.isInitialized);
    const isRestoringSession = useAuthStore(state => state.isRestoringSession);
    const isAuthenticated = useAuthStore(state => state.isAuthenticated);

    if (!isInitialized || isRestoringSession) {
      return <>{loading}</>;
    }
    if (!isAuthenticated) {
      return <>{fallback}</>;
    }
    return <>{children}</>;
  };
}
